<template>
    <div class="modal fade" id="registerEntityDetailsModal" role="dialog" aria-labelledby="registerEntityLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 id="registerEntityLabel">{{model.eventName}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <tabs :options="{ useUrlFragment: false, loadSavedTab: false }" cache-lifetime="10"
                          @changed="tabChanged">

                        <tab id="generalTab" :name="$t('registers.events.generalData.title')">
                            <div v-if="loading" class="loader"></div>
                            <div v-if="!loading">
                                <div v-if="register" class="mt-3">
                                    <event-general-data :model="register.registerEntityExtension"
                                                        :registerId="model.registerId"
                                                        :entryId="model.registerEntityId"
                                                        :details="true"
                                                        :isEvent="model.isEvent"
                                                        :registerName="'Events'"></event-general-data>
                                </div>
                                <div v-if="register">
                                    <panel v-for="(panel, index) in register.panels"
                                           :panel="panel"
                                           :details="true"
                                           :key="'generalTabPanel' + index"></panel>
                                </div>

                                <!--                            <DetailsCard v-model="model"-->
                                <!--                                         v-if="showDetails"-->
                                <!--                                         @cancel="onCancel">-->
                                <!--                            </DetailsCard>-->
                            </div>
                        </tab>

                        <tab id="relatedFormTab" :name="$t('registers.forms.management')">
                            <div v-if="relatedFormTabActive">
                                <forms-management :eventId="Number(model.registerEntityId)"
                                                  :details="false"
                                                  :show-btn-settings="false"
                                                  :can-write="false"
                                                  :is-locked-for-edit="true"
                                                  :showRelatedForms="true"
                                                  :showHeader="false">
                                </forms-management>
                            </div>
                        </tab>

                        <tab id="rankingTab" :name="$t('registers.events.evaluation.criteria.title')">
                            <div v-if="rankingTabActive">
                                <RankingCriteriaDetails :event-id="Number(model.registerEntityId)"
                                                        :is-locked-for-edit="true">
                                </RankingCriteriaDetails>
                            </div>
                        </tab>

                        <tab id="participationRequestsTab"
                             :name=" $t('registers.events.evaluation.participationRequests.title')">
                            <div v-if="participationRequestsTabActive">
                                <ParticipationRequestsGrid :eventId="Number(model.registerEntityId)"
                                                           :showBtns="false"
                                                           :showSettingsBtn="false"
                                                           :is-locked-for-edit="true">
                                </ParticipationRequestsGrid>
                            </div>
                        </tab>

                        <tab id="tempRankingTab" :name="$t('registers.events.evaluation.tempRanking.title')">
                            <div v-if="tempRankingTabActive">
                                <temp-ranking-management ref="tempRankingCriteria"
                                                         :eventId="Number(model.registerEntityId)"
                                                         :is-locked-for-edit="true"></temp-ranking-management>
                            </div>
                        </tab>

                        <tab id="participantsTab" :name="$t('registers.events.participants.title')">
                            <div v-if="participantsTabActive">
                                <participants-management ref="participantsManagement"
                                                         :registerId="Number(model.registerId)"
                                                         :showSettingsBtn="false"
                                                         :entryId="Number(model.registerEntityId)"
                                                         :is-locked-for-edit="true"></participants-management>
                            </div>
                        </tab>

                        <tab id="lecturersTab" :name="$t('registers.lecturers.title')">
                            <div v-if="lecturersTabActive">
                                <lecturers-management ref="lecturersManagement"
                                                      :registerId="Number(model.registerId)"
                                                      :entryId="Number(model.registerEntityId)"
                                                      :is-locked-for-edit="true"></lecturers-management>
                            </div>
                        </tab>

                        <tab id="budgetTab" :name="$t('registers.events.budget.title')">
                            <div v-if="budgetTabActive">
                                <budget-planning :register-entity-id="Number(model.registerEntityId)"
                                                 :event-date-from="eventDateFrom"
                                                 :is-locked-for-edit="true"
                                                 :event-date-to="eventDateTo"></budget-planning>
                            </div>
                        </tab>

                        <tab id="expensesTab" :name="$t('registers.events.costs.title')">
                            <div v-if="expensesTabActive">
                                <expenses :register-entity-id="Number(model.registerEntityId)"
                                          :is-locked-for-edit="true"
                                          :event-date-from="eventDateFrom"
                                          :event-date-to="eventDateTo"></expenses>
                            </div>
                        </tab>

                        <tab id="budgetReportTab" :name="$t('registers.events.budgetReport.title')">
                            <div v-if="budgetReportTabActive">
                                <budget-report :register-entity-id="Number(model.registerEntityId)"
                                               :event-date-from="eventDateFrom"
                                               :is-locked-for-edit="true"
                                               :event-date-to="eventDateTo"></budget-report>
                            </div>
                        </tab>

                        <tab id="hallEventTab" :name="$t('scheduler.agenda')">
                            <div v-if="hallEventTabActive">
                                <hall-event-management :eventId="Number(model.registerEntityId)"
                                                       :is-locked-for-edit="true"
                                                       :show-filter="false"
                                                       :details="true"></hall-event-management>
                            </div>
                        </tab>

                        <tab id="organizationalCalendarTab" :name="$t('organizationalCalendar.title')">
                            <div v-if="organizationalCalendarTaActive">
                                <organizational-calendar-management :eventId="Number(model.registerEntityId)"
                                                                    :is-locked-for-edit="true"
                                                                    :details="true"></organizational-calendar-management>
                            </div>
                        </tab>

                        <tab id="documentsTab" :name="$t('registers.events.organizationalDocs')">
                            <div v-if="docsTabActive">
                                <event-docs ref="eventDocs"
                                            :is-locked-for-edit="true"
                                            :eventId="Number(model.registerEntityId)"></event-docs>
                            </div>
                        </tab>

                        <tab id="subscriptionsTab" :name="$t('registers.events.subscriptions.title')">
                            <div v-if="subscriptionsTabActive">
                                <event-subscriptions-grid ref="eventSubscriptionsGrid"
                                                          :showHideButton="false"
                                                          :showSettingsBtn="false"
                                                          :relatedEventId="Number(model.registerEntityId)"
                                                          :hiddenColumns="[
                                                            'eventId',
                                                            'eventName',
                                                            'eventStartDate',
                                                            'eventEndDate',
                                                            'eventSubscriptionStartDate',
                                                            'eventSubscriptionEndDate'
                                                        ]"></event-subscriptions-grid>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {DynamicRegisterDetails, DynamicRegisterPersonModel, EditorRegister} from '../../../models/models';
    import Panel from '../../dynamic/Panel';
    import EventGeneralData from '../../dynamic/EventGeneralData';
    import DetailsCard from './DetailsCard';
    import FormsManagement from '../../dynamic/FormsManagement';
    import RankingCriteriaDetails from '../../dynamic/view/RankingCriteriaDetails';
    import ParticipationRequestsGrid from '../../../components/participants/ParticipationRequestsGrid';
    import TempRankingManagement from '../../dynamic/ranking/TempRankingManagement';
    import ParticipantsManagement from '../../../components/participants/ParticipantsManagement';
    import LecturersManagement from '../../../components/lecturers/LecturersManagement';
    import BudgetPlanning from '../../../components/budget/BugetPlanning';
    import Expenses from '../../budget/Expenses';
    import BudgetReport from '../../budget/BudgetReport';
    import HallEventManagement from '../../../components/scheduler/HallEventManagement';
    import OrganizationalCalendarManagement from '../../../components/organizationalCalendar/Management';
    import EventDocs from '../../../components/docs/event-docs';
    import EventSubscriptionsGrid from '../../../components/subscriptions/EventSubscriptionsGrid';
    import CustomTabs from '../../../components/tab/CustomTabs';
    import { DynamicRegister } from "../../../models/enums";

    Vue.use(CustomTabs);

    export default {
        components: {
            DetailsCard,
            FormsManagement,
            RankingCriteriaDetails,
            ParticipationRequestsGrid,
            TempRankingManagement,
            ParticipantsManagement,
            LecturersManagement,
            BudgetPlanning,
            Expenses,
            BudgetReport,
            HallEventManagement,
            OrganizationalCalendarManagement,
            EventDocs,
            EventSubscriptionsGrid,
            Panel,
            EventGeneralData
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDetails: false,
                model: new DynamicRegisterDetails(),
                relatedFormTabActive: false,
                rankingTabActive: false,
                tempRankingTabActive: false,
                participationRequestsTabActive: false,
                lecturersTabActive: false,
                participantsTabActive: false,
                budgetTabActive: false,
                expensesTabActive: false,
                budgetReportTabActive: false,
                importTabActive: false,
                hallEventTabActive: false,
                organizationalCalendarTaActive: false,
                subscriptionsTabActive: false,
                docsTabActive: false,
                eventDateFrom: '',
                eventDateTo: '',
                register: null,
                people: [],
                loading:false
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', {...this.model});
                this.model = new DynamicRegisterDetails();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            },
            resetActiveTabs() {
                this.relatedFormTabActive = false;
                this.rankingTabActive = false;
                this.tempRankingTabActive = false;
                this.participationRequestsTabActive = false;
                this.lecturersTabActive = false;
                this.participantsTabActive = false;
                this.budgetTabActive = false;
                this.expensesTabActive = false;
                this.budgetReportTabActive = false;
                this.importTabActive = false;
                this.hallEventTabActive = false;
                this.organizationalCalendarTaActive = false;
                this.subscriptionsTabActive = false;
                this.docsTabActive = false;
            },
            tabChanged(selectedTab) {
                if (!selectedTab) {
                    return;
                }

                // this.resetActiveTabs();

                switch (selectedTab.tab.id) {
                    case 'relatedFormTab':
                        if (this.relatedFormTabActive === false) {
                            this.relatedFormTabActive = true;
                        }
                        break;
                    case 'rankingTab':
                        if (this.rankingTabActive === false) {
                            this.rankingTabActive = true;
                        }
                        break;
                    case 'participationRequestsTab':
                        if (this.participationRequestsTabActive === false) {
                            this.participationRequestsTabActive = true;
                        }
                        break;
                    case 'tempRankingTab':
                        if (this.tempRankingTabActive === false) {
                            this.tempRankingTabActive = true;
                        }
                        break;
                    case 'participantsTab':
                        if (this.participantsTabActive === false) {
                            this.participantsTabActive = true;
                        }
                        break;
                    case 'lecturersTab':
                        if (this.lecturersTabActive === false) {
                            this.lecturersTabActive = true;
                        }
                        break;
                    case 'budgetTab':
                        if (this.budgetTabActive === false) {
                            this.budgetTabActive = true;
                            this.expensesTabActive = false;
                        }
                        break;
                    case 'expensesTab':
                        if (this.expensesTabActive === false) {
                            this.expensesTabActive = true;
                            this.budgetTabActive = false;
                            this.budgetReportTabActive = false;
                        }
                        break;
                    case 'budgetReportTab':
                        if (this.budgetReportTabActive === false) {
                            this.budgetReportTabActive = true;
                            this.expensesTabActive = false;
                        }
                        break;
                    case 'importTab':
                        if (this.importTabActive === false) {
                            this.importTabActive = true;
                        }
                        break;
                    case 'hallEventTab':
                        if (this.hallEventTabActive === false) {
                            this.hallEventTabActive = true;
                        }
                        break;
                    case 'organizationalCalendarTab':
                        if (this.organizationalCalendarTaActive === false) {
                            this.organizationalCalendarTaActive = true;
                        }
                        break;
                    case 'subscriptionsTab':
                        if (this.subscriptionsTabActive === false) {
                            this.subscriptionsTabActive = true;
                        }
                        break;
                    case 'documentsTab':
                        if (this.docsTabActive === false) {
                            this.docsTabActive = true;
                        }
                        break;
                    default: {
                    }
                        break;
                }
            },
            loadRegisterStructureWithEntities() {
                this.loading = true;

                const entryId = Number(this.model.registerEntityId);

                this.$http.get(`/api/DynamicRegisters/people/${entryId}`).then(result => {
                    if (result && result.data) {
                        result.data.forEach(person => {
                            this.people.push(new DynamicRegisterPersonModel(person));
                        });
                    }
                });

                this.$http
                    .get(`/api/dynamicRegisters/${this.model.registerId}/values/${entryId}`)
                    .then(result => {
                        this.register = new EditorRegister(result.data);
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    }).then(() => {
                    this.$store.dispatch('setCurrentRegisterData', this.register);
                });
            },
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.register=null;
                    this.model = new DynamicRegisterDetails(this.value);
                    this.model.registerId = DynamicRegister.Events;
                    this.loadRegisterStructureWithEntities();
                    this.showDetails = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
